import { Component, OnInit } from "@angular/core";
import { BaseService } from "src/app/Services/Base.service";
declare var $: any;

@Component({
  selector: "app-services",
  templateUrl: "./services.component.html",
  styleUrls: ["./services.component.scss"]
})
export class ServicesComponent implements OnInit {
  lang: string;

  constructor(private base: BaseService) { }

  ngOnInit() {
    this.lang = this.base.getLang();
    $(document).ready(function () {
      var body = $("html, body");
      body.stop().animate({ scrollTop: 0 }, 500, "swing");
      $(".nav-item").removeClass("active");
      $("#services").addClass("active");
    });
  }

  ngAfterContentChecked(): void {
    this.lang = this.base.getLang();
  }
  
  onLoading(id) {
    $("#" + id).fadeOut("slow");
  }
}
